// 웹 전체 다크 모드 단일 설정.
// 홈 웹의 토글 하나가 .thuthi.kr 쿠키(thuthi_theme = system | light | dark)를 쓰고, 모든 웹(ntfy·deal·iot·auth·홈,
// 어시스턴트 시트)이 그 값을 따른다. 앱 안에서는 홈이 네이티브 야간 모드도 같이 바꾼다(브리지 setThemeMode).
// 첫 페인트 스크립트(vite.ts 의 thuthiWeb 플러그인이 각 웹 index.html 에 넣는다)도 같은 쿠키를 읽는다.
import { cookieThemeStorage, readThemeMode, setThemeMode, startThemeSync, type ThemeMode } from "@thuthi/ui/lib/theme"

export type { ThemeMode }

import { THEME_COOKIE } from "./theme-cookie"

export { THEME_COOKIE }

const storage = cookieThemeStorage(THEME_COOKIE, ".thuthi.kr")

/** 진입에서 1회 — 적용하고, 화면 복귀·시스템 설정 변경 때 다시 읽는다(다른 웹에서 바꾼 값 반영). */
export const startThuthiTheme = () => startThemeSync(storage)

export const getThuthiTheme = (): ThemeMode => readThemeMode(storage)

export const setThuthiTheme = (mode: ThemeMode) => setThemeMode(storage, mode)
